const CATEGORIES = [
  'search',
  'recent',
  'smileys',
  'people',
  'nature',
  'foods',
  'activity',
  'places',
  'objects',
  'symbols',
  'flags',
  'custom',
]
const SKIN_TONES = [1, 2, 3, 4, 5, 6]

const toMap = (keys, getValue) =>
  keys.reduce((map, key) => ({ ...map, [key]: getValue(key) }), {})

export default t => ({
  search: t('chat.picker.search'),
  clear: t('chat.picker.clear'), // Accessible label on "clear" button
  notfound: t('chat.picker.notFound'),
  skintext: t('chat.picker.skinText'),
  categories: toMap(CATEGORIES, key => t(`chat.picker.categories.${key}`)),
  categorieslabel: t('chat.picker.categoriesLabel'), // Accessible title for the list of categories
  skintones: toMap(SKIN_TONES, key => t(`chat.picker.skinTones.${key}`)),
})
